/**
 * 급여 편집 권한 판정 정본 (2026-08-04 결정)
 *
 * 실장은 급여를 통째로 수정하지 않고 '매달 실제로 발생하는 변동분'만 입력한다.
 * 월급·비과세·식대·기숙사는 채용·계약 조건이므로 관리자(원장) 고유 영역이다.
 *
 * 이 파일이 '누가 어떤 급여 필드를 편집할 수 있는가'의 단일 정본이다.
 * 화면(EmployeeTableSection)과 저장 경로(usePayrollBusinessLogic)가 모두 여기를 경유해야
 * 잠금과 저장 범위가 어긋나지 않는다.
 */

/** 제한 편집 권한으로 손댈 수 있는 급여 필드 — 이 둘이 전부다. */
export const LIMITED_EDITABLE_PAYROLL_FIELDS = ['overtimeMinutes', 'individual'] as const;

export type LimitedEditablePayrollField = typeof LIMITED_EDITABLE_PAYROLL_FIELDS[number];

/** 급여 편집 모드 — full(전체) / limited(두 필드) / none(불가) */
export type PayrollEditMode = 'full' | 'limited' | 'none';

/**
 * 보유 권한 목록에서 급여 편집 모드를 판정한다.
 * edit_payroll(전체)이 있으면 limited 여부와 무관하게 full이다.
 */
export const getPayrollEditMode = (permissions?: readonly string[] | null): PayrollEditMode => {
  if (!permissions || permissions.length === 0) return 'none';
  if (permissions.includes('edit_payroll')) return 'full';
  if (permissions.includes('edit_payroll_limited')) return 'limited';
  return 'none';
};

/**
 * 이 모드에서 해당 급여 필드를 편집할 수 있는가.
 * limited 모드는 LIMITED_EDITABLE_PAYROLL_FIELDS에 있는 필드만 허용한다.
 */
export const canEditPayrollField = (mode: PayrollEditMode, field: string): boolean => {
  if (mode === 'full') return true;
  if (mode === 'none') return false;
  return (LIMITED_EDITABLE_PAYROLL_FIELDS as readonly string[]).includes(field);
};

/** 화면에서 급여 관련 입력을 하나라도 쓸 수 있는가 (읽기 전용 표시 판정용) */
export const canEditAnyPayrollField = (mode: PayrollEditMode): boolean => mode !== 'none';
